import PracticeAreasContent from "$lib/data/generated/content/practice areas/data.json";

import { uploads as PracticeAreasUploads } from "$lib/data/generated/uploads/practice areas/uploads";

const content = {
	["practice areas"]: PracticeAreasContent
};
const uploads = {
	...PracticeAreasUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
